function setCollapsedStyle(el, binding) {
  if (binding.modifiers.useClass) {
    el.classList.add('collapsed')
  } else {
    el.style.display = 'none'
  }
}

function setExpandedStyle(el, binding) {
  if (binding.modifiers.useClass) {
    el.classList.remove('collapsed')
  } else {
    el.style.display = ''
  }
}

export default {
  bind(el, binding) {
    el.style.transition = 'max-height 200ms ease-out'

    binding.value
      ? setExpandedStyle(el, binding)
      : setCollapsedStyle(el, binding)
  },
  update(el, binding) {
    if (binding.value === binding.oldValue) {
      return
    }

    const setupInitialStyles = () => {
      setExpandedStyle(el, binding)
      el.style.overflowY = 'hidden'
    }

    const resetCommonStyles = () => {
      el.style.overflowY = ''
      el.style.maxHeight = ''
    }

    const onTransitionEndOnce = (callback) => {
      el.ontransitionend = (e) => {
        if (e.propertyName === 'max-height' && e.target === el) {
          callback()
          el.transitionend = undefined
        }
      }
    }

    if (binding.value) {
      /* step1: setup initial styles */
      setupInitialStyles()

      /* step2: reset max-height and measure height of element when fully expanded */
      el.style.maxHeight = ''
      const expandedHeight = el.offsetHeight

      /* step3: reset height to zero again */
      el.style.maxHeight = '0px'

      window.requestAnimationFrame(() => {
        // step4: trigger an transition to the expanded height
        el.style.maxHeight = `${expandedHeight}px`

        // step5: cleanup
        // when setting expand = true on page load, the transition will not execute (but the styles will apply)
        // so we need to detect that and call resetCommonStyles manually
        const transitionWasAlreadyDone =
          window.getComputedStyle(el).maxHeight === el.style.maxHeight
        if (transitionWasAlreadyDone) {
          resetCommonStyles()
        } else {
          onTransitionEndOnce(resetCommonStyles)
        }
      })
    } else {
      /* step1: setup initial styles */
      setupInitialStyles()

      /* step2: set height to initial height */
      el.style.maxHeight = `${el.offsetHeight}px`

      window.requestAnimationFrame(() => {
        /* step3: animate to zero height */
        el.style.maxHeight = '0px'

        /* step4: reset and truly hide the content */
        onTransitionEndOnce(() => {
          resetCommonStyles()
          setCollapsedStyle(el, binding)
        })
      })
    }
  },
}
